/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactWithRelations } from '../../models/contact-with-relations';

export interface InventoryGetContacts$Params {
  inventoryId: string;
}

export function inventoryGetContacts(http: HttpClient, rootUrl: string, params: InventoryGetContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, inventoryGetContacts.PATH, 'get');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContactWithRelations>>;
    })
  );
}

inventoryGetContacts.PATH = '/inventory/contacts';
